import { useState } from 'react';

import { Button } from '@/shared/ui/Button';
import { Modal } from '@/shared/ui/Modal';
import { Textarea } from '@/shared/ui/Textarea';

/**
 * Bloqueio do corretor com a "Justificativa de bloqueio" do OnPoint.
 *
 * O servidor recusa o bloqueio sem justificativa e grava a data. A tela pede o
 * texto antes de mandar, para que a pessoa nao descubra a exigencia pela recusa.
 */
export function BlockBrokerDialog({
  open,
  nome,
  enviando,
  onConfirmar,
  onClose,
}: {
  open: boolean;
  nome: string;
  enviando: boolean;
  onConfirmar: (justificativa: string) => void;
  onClose: () => void;
}) {
  const [justificativa, setJustificativa] = useState('');
  const vazia = justificativa.trim() === '';

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={`Bloquear ${nome}`}
      description="O corretor bloqueado sai dos negocios novos. A data do bloqueio e a justificativa ficam no cadastro e no historico."
      size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={enviando}>
            Cancelar
          </Button>
          <Button
            variant="danger"
            loading={enviando}
            disabled={vazia}
            onClick={() => onConfirmar(justificativa.trim())}
          >
            Bloquear
          </Button>
        </>
      }
    >
      <Textarea
        label="Justificativa de bloqueio"
        required
        maxLength={2000}
        value={justificativa}
        onChange={(evento) => setJustificativa(evento.target.value)}
      />
    </Modal>
  );
}
